import { baseColors } from '@/themes/baseColors'

export function getFilterDropdownStyles({ isMobile }: { isMobile: boolean }) {
  return {
    container: (base: Record<string, unknown>) => {
      return {
        ...base,
        width: '100%',
        height: '100%',
        borderRadius: 0,
        '&:focus-visible': {
          outline: 0,
          border: 0,
        },
      }
    },
    control: (base: Record<string, unknown>) => {
      return {
        ...base,
        height: '100%',
        border: 0,
        borderRadius: '0 !important',
        // TODO: These once came from tailwind config. How can we get them again
        fontSize: isMobile
          ? '1rem'
          : '0.875rem',
        borderBottom: '1px solid transparent !important',
        minHeight: 'fit-content',
        '&:hover': {
          borderTop: '0px !important',
          borderLeft: '0px !important',
          borderRight: '0px !important',
          borderBottomWidth: '1px !important',
          borderBottomStyle: 'solid !important',
          borderBottomColor: `${baseColors.green['40']} !important`,
        },
        '&.react-select__control--is-focused': {
          outline: 'none !important',
          boxShadow: 'none !important',
          borderColor: `${baseColors.green['40']} !important`,
        },
      }
    },
    valueContainer: (base: Record<string, unknown>) => ({
      ...base,
      maxWidth: '100%',
      padding: '0 !important',
      marginLeft: '5px !important',
      '& input': {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis !important',
      },
      '&:focus-visible': {
        outline: 0,
        border: 0,
      },
    }),
    menu: (base: Record<string, unknown>) => ({
      ...base,
      zIndex: 11, // to override histogram z-index
    }),
    menuList: (base: Record<string, unknown>) => ({
      ...base,
      // TODO: These once came from tailwind config. How can we get them again
      fontSize: isMobile
        ? '1rem'
        : '0.875rem',
    }),
    clearIndicator: (base: Record<string, unknown>) => ({
      ...base,
      padding: '0',
    }),
  }
}
